import { useEffect, useState } from "react";

const DEFAULT_MESSAGE =
  "Hello 👋\nI need help with an issue on your platform.";

export default function WhatsAppChat({
  phones = ["15124226378", "447311128520"], // multiple numbers
  message = DEFAULT_MESSAGE,
  position = "right",
  bottom = 20,
}) {
  const [url, setUrl] = useState("");
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    // pick one (random)
    const phone = phones[Math.floor(Math.random() * phones.length)];

    setUrl(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`);
  }, [phones, message]);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with support on WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "fixed",
        bottom,
        [position]: 20,
        width: 56,
        height: 56,
        backgroundColor: "#25D366",
        borderRadius: "50%",
        boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        cursor: "pointer",
        transition: "transform 0.2s ease",
        transform: hovered ? "scale(1.05)" : "scale(1)",
      }}
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        style={{ width: 32, height: 32 }}
      />

      {hovered && (
        <span
          style={{
            position: "absolute",
            bottom: "50%",
            transform: "translateY(50%)",
            [position === "left" ? "left" : "right"]: "70px",
            background: "#111",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: 6,
            fontSize: 12,
            whiteSpace: "nowrap",
          }}
        >
          Chat with us
        </span>
      )}
    </a>
  );
}
